import { render } from "./Client.vue?vue&type=template&id=665e8248&scoped=true"
import script from "./Client.vue?vue&type=script&lang=js"
export * from "./Client.vue?vue&type=script&lang=js"

import "../../assets/css/client.css?vue&type=style&index=0&id=665e8248&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665e8248"]])

export default __exports__